import { Switch, withStyles } from "@material-ui/core";
import { colorPalette } from "../../colorPalette";
export const AntSwitch = withStyles((theme) => ({
    switchBase: {
        color: colorPalette.white,
        '&$checked': {
            transform: 'translateX(19px)',
            color: colorPalette.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: colorPalette.green700,
            },
        },
    },
    track: {
        border: `1px solid ${colorPalette.gray500}`,
        borderRadius: 40,
        opacity: 1,
        backgroundColor: colorPalette.gray500,
    },
    checked: {},
}))(Switch);
